import React, { useState, useEffect } from "react";
import Menu from "../common/Menu/Menu";
import NotificationCenter from "../NotificationCenter/NotificationCenter";
import { useTheme } from "../../context/ThemeContext";
import "./Layout.scss";

const Layout = ({ children }) => {
  const getIsDesktop = () => window.innerWidth >= 1000;
  const { isDark, toggleTheme } = useTheme();

  const [isDesktop, setIsDesktop] = useState(getIsDesktop());
  const [isSidebarOpen, setIsSidebarOpen] = useState(getIsDesktop());

  // Atualiza o estado ao montar e ao redimensionar
  useEffect(() => {
    const handleResize = () => {
      const desktop = getIsDesktop();
      setIsDesktop(desktop);
      // Não alteramos mais o estado da sidebar aqui para permitir controle manual em qualquer dispositivo
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Toggle funciona em qualquer dispositivo
  const handleToggle = () => {
    setIsSidebarOpen((prev) => !prev);
  };
  
  // Fechar o menu quando clicar fora dele (apenas no mobile)
  const handleOverlayClick = () => {
    if (!isDesktop && isSidebarOpen) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <>
      <div className={`top-bar ${!isSidebarOpen ? 'sidebar-closed' : ''}`}>
        <div className="top-bar-left">
          <button
            className={`menu-toggle ${isSidebarOpen ? "open" : ""}`}
            onClick={handleToggle}
            aria-label="Toggle menu"
          >
            <div className="hamburger">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>
        </div>
        
        <div className="top-bar-right">
          <button 
            className="theme-toggle" 
            onClick={toggleTheme}
            aria-label="Alternar tema"
            type="button"
            title={isDark ? "Mudar para tema claro" : "Mudar para tema escuro"}
          >
            <span>{isDark ? '🌙' : '☀️'}</span>
          </button>
          <NotificationCenter />
        </div>
      </div>
      
      {/* Overlay para fechar o menu quando clica fora dele */}
      <div 
        className={`sidebar-overlay ${isSidebarOpen && !isDesktop ? "active" : ""}`} 
        onClick={handleOverlayClick}
      ></div>
      
      <Menu isOpen={isSidebarOpen} />
      <div className={`main-content ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
        {children}
      </div>
    </>
  );
};

export default Layout;